import Vue from "vue";
import { authService } from "@/services/auth";

const refreshPermissions = async () => {
    // Clear all previously set rules (when switching users)
    Vue.prototype.$ability.update([]);

    // If the user is not logged in, there's no point continuing
    if (!(await Vue.prototype.$auth.getUser())) return;

    const perms = await authService.getPermissions();
    Vue.prototype.$ability.update(perms);
};

export const usePermissions = () => {
    return { refreshPermissions };
};
